import React, { SVGProps } from 'react'

import { Check } from './Check'
import { Cancel } from './Cancel'
import { Reset } from './Reset'
import { Card } from './Card'
import { CaretDown } from './CaretDown'

const icons = {
  check: Check,
  cancel: Cancel,
  reset: Reset,
  card: Card,
  caretDown: CaretDown,
}

export type IconName = keyof typeof icons

interface Props extends Omit<SVGProps<SVGElement>, 'width' | 'height'> {
  icon: IconName
  size?: number
}

export const Icon: React.FC<Props> = (props) => {
  const { icon, size = 12, fill = 'currentColor', ...svgProps } = props

  const Component = icons[icon]

  return <Component {...svgProps} fill={fill} width={size} height={size} />
}
